import ps from 'pubsub-js';
import sliders from './sliders';

/**
 * Misc
 * @constructor
 * @requires pubsub-js
 * @requires fetcher
 * @requires form-utils
 */
class Misc {

  /**
   * Inits the module with necessary functions
   * @method
  **/
  constructor() {

    this._fixHeader = this._fixHeader.bind(this);
    this._scroll = this._scroll.bind(this);
    this._compare = this._compare.bind(this);
    this._openCompare = this._openCompare.bind(this);
    this._bind = this._bind.bind(this);

    this._bind();
    this._fixHeader(document.querySelector('#nav'));
    // this._fixHeader(document.querySelector('.inner-nav'));

    if( !document.getElementById('youtube-api-script') ){
      var tag = document.createElement('script');
      tag.id = 'youtube-api-script';
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

  }

  _bind() {

    document.body.listen('click', '[data-scroll]', this._scroll);
    document.body.listen('change', '[data-compare]', this._compare);
    document.body.listen('click', '[data-remove]', (e) => {
      this._compare(e, true);
    });
    document.body.listen('change', '[data-submit]', (e) => {
      e.currentTarget.form.submit();
    });

  }

  _compare(e, remove){

    const trigger = e.currentTarget,
          zone = document.querySelector('[data-comparator]'),
          products = zone.querySelector('.products'),
          product = trigger.closest('.product'),
          id = trigger.name || trigger.getAttribute('for'),
          add = typeof remove !== 'undefined' ? !remove : trigger.checked;

    if( ( products.querySelectorAll('.product').length == 3 && add ) || (products.querySelectorAll('.product').length == 0 && !add ) ){
      trigger.checked = false;
      return;
    }

    if( add ){
      const name = 'compare-'+id,
            newProduct = product.querySelector('form') ? product.querySelector('form .wp').cloneNode(true) : product.querySelector('.wp').cloneNode(true),
            container = document.createElement('article'),
            input = document.createElement('input'),
            buttons = `<div class="ct"><div class="buttons"><label data-remove class="bt-remove" for="${name}"><span>Supprimer</span></label></div></div>`;

      container.className = 'product';
      input.type = 'checkbox';
      input.name = name;
      input.id = name;
      input.checked = true;

      newProduct.querySelector('.head').removeChild(newProduct.querySelector('.bt-compare'));
      newProduct.removeChild(newProduct.querySelector('.ct'));
      newProduct.insertAdjacentHTML('beforeend', buttons);

      container.appendChild(newProduct);

      products.insertAdjacentElement('beforeend', input);
      products.insertAdjacentElement('beforeend', container);
      this._openCompare(zone, products);
    }
    else{
      let elt;

      if( remove ){
        // delete via supprimer bt
        elt = document.getElementById(id);
        document.getElementById(id.replace('compare-','')).checked = false;
      }
      else{
        // delete via uncheck compare
        elt = document.getElementById('compare-'+id);
      }

      window.requestAnimationFrame( () => {
        elt.checked = false;
        elt.nextElementSibling.addEventListener('animationend', () => {
          elt.parentNode.removeChild(elt.nextElementSibling);
          elt.parentNode.removeChild(elt);
          this._openCompare(zone, products);
        });
      });

    }

  }

  _openCompare(zone, products){
    document.querySelector('[data-nb]').textContent = products.querySelectorAll('.product').length;
    if( products.querySelectorAll('.product').length > 0 ){
      zone.classList.remove('inactive');
    }
    else{
      zone.classList.add('inactive');

      if( zone.querySelector('[data-toggle][aria-expanded="true"]') ){
        zone.querySelector('[data-toggle]').click();
      }
    }
  }

  youtube( player, fn ){
    player.contentWindow.postMessage(window.JSON.stringify( { event: 'command', func: fn } ), '*')
  }

  youtubeAutoplay(elt){

    window.onYouTubeIframeAPIReady = () => {
      elt.player = new YT.Player(elt, {
        events: {
          'onReady': (e)=>{
            e.target.playVideo();
          }
        }
      });
    }

  }

  youtubeStopSlider(elt, slider){

    window.onYouTubeIframeAPIReady = () => {
      elt.player = new YT.Player(elt, {
        events: {
          'onStateChange': (e)=>{
            slider.sliderDom.autoplay.stop();
          }
        }
      });
    }

  }

  _scroll( e ){

    const trigger = e.originalEvent ? e.currentTarget : e,
          smooth = { behavior: 'smooth' },
          scrollData = trigger.dataset && trigger.dataset.scroll ? Object.assign(JSON.parse(trigger.dataset.scroll), smooth) : smooth;

    let id;

    if( e.originalEvent ){
      e.preventDefault();

      if( trigger.href ){
        id = trigger.getAttribute('href');
      }
    }
    else{
      id = trigger.href;
    }

    if( !("top" in scrollData) && trigger.href ){
      if( !document.querySelector( id ) ){
        console.log("Aucun élément avec l'ID "+id);
        return;
      }
      // document.querySelector(trigger.getAttribute('href')).scrollIntoView(smooth);
      scrollData.top = document.querySelector( id ).offsetTop - ( document.querySelector('header[role="banner"]') ? document.querySelector('header[role="banner"]').offsetHeight : 0) - 10;
    }
    window.scroll( scrollData );

  }

  _fixHeader(elt){

    if( !elt ){
      return;
    }

    const menu = elt,
          sticky = !!window.CSS && window.CSS.supports('position','sticky');

    if( !menu || window.istouch ){
      return;
    }

    let isAdded = false,
        menuPosition = menu.getBoundingClientRect();

    window.addEventListener('scroll', function() {
      menuPosition = menu.getBoundingClientRect();
      if( 0 >= menuPosition.top && !isAdded ){
        if( !sticky ){
          menu.style.height = menu.offsetHeight+'px';
          menu.classList.add('fixed');
        }
        menu.classList.add('fix');
        isAdded = true;
      }
      else if( 0 < menuPosition.top && isAdded ){
        if( !sticky ){
          menu.style.height = '';
          menu.classList.remove('fixed');
        }
        menu.classList.remove('fix');
        isAdded = false;
      }
    });

  }

}

export default new Misc();
